import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    toggleChildren(event) {
        let parentName = event.currentTarget.dataset.parentName;
        let parentLis = document.querySelectorAll(`li[data-id="${parentName}"]`);
        let isParentToggle = event.target.classList.contains("rotate-180")

        event.target.classList.toggle("rotate-180");
        parentLis.forEach((parentLi) => {
            parentLi.classList.toggle("hidden");
            parentLi.classList.add("bg-blue-50");
            if (isParentToggle) {
                this.toggleChildVisibility(parentLi)
            }
        });
    }

    toggleChildVisibility(parentLi) {
        let childName = parentLi.dataset.currentName;
        let childLis = document.querySelectorAll(`li[data-id="${childName}"]`);
        if (childLis.length > 0) {
            childLis.forEach((childLi) => {
                childLi.classList.add("hidden");
                let icon = parentLi.querySelector('[data-lucide="chevron-down"]')
                if (icon) icon.classList.remove("rotate-180")
                this.toggleChildVisibility(childLi);
            });
        }
    }
}